export default {
  id: 'canvas-tooltip',
  class: 'canvas-tooltip',
  caretSize: 8,
  animationSpeed: 0.2
}
